import { PermissionsScope } from '../../policies'

export const SUPPLIER_FRAGMENT = 'supplier'
export const SUPPLIER_SCOPE: PermissionsScope = 'suppliers'
